import React, { useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import * as routes from 'constants/routes';
import { ContentContext } from '../../contexts/ContentContext';
import Content from '../content/Content';
import ContentImg from '../content/ContentImg';
import ContentAdd from '../content/ContentAdd';
import ContactForm from './ContactForm';
import ReactBody from 'react-body';
import { Helmet } from 'react-helmet-async';
import Lottie from 'lottie-react';
import lottieExtensions from '../../data/lottie-extensions.json';

const Training = (props) => {
  
  const { siteContent } = useContext(ContentContext);

  useEffect(() => {
    window.scrollTo(0,0);
  }, []);

  return (siteContent.training ?
    <section id="training">
      <Helmet>
        <title>CADD Community - Training</title>
      </Helmet>
      
      <div className="hero hero-color hero-secondary">
        <div className="content-wrap">
          <div className="hero-content">
            <Content
              page="training"
              item="header"
              type="content" />
            <ContactForm />
          </div>
          <div className="hero-lottie">
            <Lottie animationData={lottieExtensions} />
          </div>
        </div>
      </div>

      <div className="training-sub content-sub">
        <div className="content-wrap">
          <Content
            page="training"
            item="sub"
            type="content" />
        </div>
      </div>

      <div className="training-posts content-posts content-posts-internal">

        { siteContent.training.posts ? siteContent.training.posts.map((post, index) => 
          <div className="content-main" id={`content-${index}`} key={index}>
            <ContentImg
              page="training"
              item="posts"
              itemIndex={index}
              type="img" />
            <Content
              page="training"
              item="posts"
              itemIndex={index}
              type="content" />
          </div> 
        ) : null }

        <ContentAdd
          page="training"
          item="posts"
          type="content" />

      </div>

      <ReactBody className="training header-secondary" />
    </section>
  : <div className="content-intro">
      <div className="content-loading page-loading" />
      <ReactBody className="training header-secondary" />
    </div>
  );
};

export default Training;